export default "__VITE_ASSET__C2rfWRyU__"